import config from "@/lib/config";
import { gql } from "@apollo/client";
import Uid2Token from "@/lib/uid2Token";
import { logicaErrorBody } from "./helper";
import { UserInputError } from "apollo-server-errors";
import { TERMS_ERROR_MESSAGES } from "@/lib/errors";
export const typeDef = gql`
  type Term {
    term_id: ID!
    id_key: String
    display_name: String
    required: Boolean
    current_revision: TermRevision
  }

  type TermRevision @cacheControl(maxAge: 120) {
    term_revision_id: Int
    term_id: Int
    number: Int
    unique_key: String
    url: String
    agreement: TermAgreement
  }

  type TermAgreement @cacheControl(scope: PRIVATE, maxAge: 120) {
    agreement_id: Int
    user_id: Int
    term_id: Int
    term_revision_number: Int
    agreed_at: String
  }

  enum TermType {
    REQUIRED
    OPTIONAL
  }

  type Query {
    terms(keys: [String], withAgreement: Boolean): [Term]
    registTerms(type: TermType!): [Term]
    loginTerms(type: TermType!, cacheMaxAge: Int): [Term]
  }

  type Mutation {
    agree(keys: [String]): [TermRevision]
  }
`;
const termTypeValue = {
  REQUIRED: "required",
  OPTIONAL: "optional"
};
export const resolvers = {
  Query: {
    terms: async (_parent, _ref, _ref2) => {
      let {
        keys,
        withAgreement
      } = _ref;
      let {
        dataSources
      } = _ref2;
      const results = await Promise.all(keys.map(async key => {
        return await dataSources.terms.getTerm(key, withAgreement);
      }));
      return results;
    },
    registTerms: async (_parent, _ref3, _ref4) => {
      let {
        type
      } = _ref3;
      let {
        dataSources
      } = _ref4;
      const keys = config.terms.regist["vod"][termTypeValue[type]];
      const results = await Promise.all(keys.map(async key => {
        return await dataSources.terms.getTerm(key, true);
      }));
      return results;
    },
    loginTerms: async (_parent, _ref5, _ref6, info) => {
      let {
        type,
        cacheMaxAge
      } = _ref5;
      let {
        req,
        res,
        dataSources
      } = _ref6;
      if (typeof cacheMaxAge === "number") {
        info.cacheControl.setCacheHint({
          maxAge: cacheMaxAge
        });
      }
      const keys = config.terms.login["vod"][termTypeValue[type]];
      let userRightIds;
      if (keys.includes("valueplan_term")) {
        userRightIds = await dataSources.user.rightIds();
      }
      const filteredKeys = keys.filter(key => {
        // ベーシックパックを購入していなければベーシックパックを外す
        if (key === "valueplan_term") {
          return userRightIds.includes(config.valuePlan.rightId);
        }
        return true;
      });
      const results = await Promise.all(filteredKeys.map(async key => {
        return await dataSources.terms.getTerm(key, true);
      }));
      const adTerm = results.find(result => result.id_key === config.terms.advertisingTerm);
      if (adTerm) {
        const uid2 = new Uid2Token(req, res);
        uid2.adTermsAgreeCache(adTerm);
      }
      return results;
    }
  },
  Mutation: {
    agree: async (_parent, _ref7, _ref8) => {
      let {
        keys
      } = _ref7;
      let {
        dataSources,
        req,
        res
      } = _ref8;
      try {
        const results = await Promise.all(keys.map(async key => {
          return dataSources.terms.agree(key);
        }));
        // 規約を更新したらuid2ようにキャッシュしている広告規約の同意状況をクリアする
        const uid2 = new Uid2Token(req, res);
        uid2.clearAdTermsAgreeCache();
        return results.flatMap(result => result.term_revisions);
      } catch (e) {
        var _body$error;
        console.log("terms agree error", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
        if (errorCode === 11007) {
          throw new UserInputError(TERMS_ERROR_MESSAGES["optOut"]);
        }
      }
    }
  },
  Term: {
    required: term => {
      const requiredKeys = [...config.terms.regist.vod.required, ...config.terms.login.vod.required];
      return requiredKeys.includes(term.id_key);
    }
  }
};